module.exports = __webpack_public_path__ + "img/common-file-text-check.139e713e.svg";